import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Button, Icon, Label } from '@atlas/ui';

import { NotificationEmitterBasePopup } from 'common/Popup/NotificationEmitterBasePopup';
import { useHidePopupSignUpDelay } from 'hooks/useHidePopupSignUpDelay';
import { useSetNextShowPopupSignUpDelay } from 'hooks/useSetNextShowPopupSignUpDelay';

const EmailVerificationPopup = () => {
  const { push: historyPush } = useHistory();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isSuccessful = searchParams.get('isSuccessful') === 'true';

  useHidePopupSignUpDelay();
  useSetNextShowPopupSignUpDelay();

  const onCloseHandler = React.useCallback(() => historyPush(pathname), [historyPush, pathname]);

  return (
    <NotificationEmitterBasePopup className="success-modal">
      <div className="popup__content">
        {isSuccessful ? (
          <Icon className="success-modal__icon" name="success" />
        ) : (
          <Icon className="error-modal__icon" name="error" />
        )}
        <Label
          className="popup__title"
          message={
            isSuccessful ? 'verification_successful_title' : 'verification_unsuccessful_title'
          }
        />
        <Label
          className="popup__text"
          message={
            isSuccessful ? 'verification_successful_message' : 'verification_unsuccessful_message'
          }
        />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={onCloseHandler} />
      </div>
    </NotificationEmitterBasePopup>
  );
};

export default EmailVerificationPopup;
